<script setup lang="ts">
//vue
import { reactive, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";

//services
import * as clienteService from "@/services/clienteService";
import {f2dec, fdata} from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";

const controle = reactive({
  parceiro: null as clienteService.Parceiro | null,
  status: "" as string,
  erro: "" as string
});

const route = useRoute();

onMounted(() => {
    console.log("Mounted Parceiro.vue");
    if (route.params.parceiroId) {
        const parceiroId = Number(route.params.parceiroId);
        controle.status = "Buscando parceiro...";
        console.log("parceiroId:", parceiroId);
        clienteService.obterParceiros({ parceiroId: parceiroId } as clienteService.ClienteParceirosFiltros)
            .then((r) => {
                controle.status = "";
                controle.parceiro = r.dados[0];
            })
            .catch((error) => {
                console.error("Erro ao buscar parceiro:", error);
                controle.status = "";
                controle.erro = error.message || "Erro desconhecido";
            });
    } else {
        controle.erro = "ID do parceiro não fornecido na URL.";
    }
});


function sair() {
    // Lógica para sair da área do cliente
    controle.status = "Saindo...";
    console.log("Saindo da área do cliente...");
    localStorage.removeItem("clienteToken");
    window.location.reload();
}

</script>

<template>
    <div class="row mt-4">
        <div class="col-md-12 text-center">
            <img :src="imgLogin" alt="Logo" class="img-fluid img-logo mb-3" />
        </div>
    </div>

     <div class="row mt-4 mb-3">
        <div class="col-md-12">
            <h2>Parceiro</h2>
        </div>
    </div>

   <div class="row">
        <div class="col-md-12">
            <h4 v-if="controle.erro == ''">{{ controle.status }}</h4>
            <h4 v-if="controle.erro != ''" class="text-danger">{{ controle.erro }}</h4>
        </div>
    </div>

    <div class="row" >
        <div class="col-md-12">
            <h3>{{controle.parceiro?.nome}}</h3>
        </div>
        <div class="col-md-9">
            <img :src="controle.parceiro?.arquivo" class="img-fluid">
        </div>
        <div class="col-md-3">
           <h6 class="desconto mb-0 fw-bold" v-if="controle.parceiro?.valorDescontoIni != null && controle.parceiro.valorDescontoIni > 0">
                Desconto: de {{ controle.parceiro.valorDescontoIni }} %  até {{ f2dec(controle.parceiro.valorDesconto)}} % 
            </h6>
            <h6 class="card-text desconto mb-0 fw-bold" v-if="controle.parceiro?.valorDescontoIni == null || controle.parceiro.valorDescontoIni == 0">
                Desconto: {{ f2dec(controle.parceiro?.valorDesconto)}} % 
            </h6>
            <div>{{controle.parceiro?.texto}}</div>
            <div v-if="controle.parceiro?.responsavel != null" class="mt-2"> Responsável: {{controle.parceiro?.responsavel}}</div>
            <div class="mt-2 fw-bold"> Telefone: {{controle.parceiro?.telefone}}</div>

            <div class="mt-3 endereco">{{controle.parceiro?.cidade?.nome}} - {{controle.parceiro?.cidade?.estado}}</div>
            <div class="endereco"> {{controle.parceiro?.logradouro}} {{controle.parceiro?.numero}}</div>
            <div class="endereco"> {{controle.parceiro?.bairro}}</div>
            <div class="endereco"> CEP: {{controle.parceiro?.cep}}</div>

            <div> CNPJ/CPF: {{controle.parceiro?.cnpj}}</div>
           
        </div>

        <div class="col-md-12 mt-3 mb-5">
            <RouterLink class="btn btn-secondary btn-sm  mb-5" to="/cliente">
                <i class="flaticon-left-arrow"></i> Voltar
            </RouterLink>
        </div>
    </div>

</template>


<style lang="css" scoped>

</style>